import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontNormal, defaultSize } from "@fdr/static-ui/Typography";

export const Container = styled.section`
  background: ${buildColor("white", "100")};
  width: 100%;
  position: relative;
  ${({ hasHeader }) =>
    hasHeader &&
    css`
      border-top: 1px solid ${buildColor("grey", "L2")};
      border-bottom: 1px solid ${buildColor("grey", "L2")};
    `}
`;

export const Title = styled.h1`
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-weight: 500;
  margin: 0;
  height: 22px;
  font-size: 16px;
`;
export const UpperSection = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  height: 48px;
  width: 100%;
  border-bottom: 1px solid ${buildColor("grey", "L2")};
  margin-bottom: 12px;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${buildColor("blue", "D1")};
  font-family: ${fontBold};
  font-weight: 700;
  font-size: ${defaultSize};
  line-height: 125%;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("grey", "L2")};
  border-radius: 50%;
  height: 48px;
  width: 48px;
  margin: 0 0 13px;

  &:hover {
    background-color: ${buildColor("navy", "100")};
  }
`;

export const TopRaceOutterContainer = styled.div`
  width: 294px;
  margin: 0 0 0 8px;
  border-radius: 4px;
  overflow: hidden;
  height: 328px;
  ${({ hasTopRace }) =>
    hasTopRace &&
    css`
      border: 1px solid ${buildColor("grey", "L2")};
    `};

  &:first-of-type {
    margin-left: 16px;
  }

  ${({ isOpeningApp }) =>
    isOpeningApp &&
    css`
      & > div {
        pointer-events: none;
      }
    `}
`;

export const LastElementContainer = styled.div`
  margin-right: calc(100% - 292px);
  max-width: 292px;
  padding-left: ${({ isFirstElement }) => (isFirstElement ? "12px" : "8px")};
  height: auto;
  min-height: 314px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LastElement = styled.div`
  background: ${buildColor("white", "100")};
  min-height: 152px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NoRacesContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 16px 12px;
  justify-content: space-between;
`;

export const NoRacesMessage = styled.span`
  display: flex;
  align-items: center;
  font-family: ${fontNormal};
  font-size: ${defaultSize};
  line-height: 125%;
  color: ${buildColor("grey", "D3")};
`;
